import Link from "next/link";

export default function SideNav() {
  return (
    <div className='hidden md:flex w-full max-w-[20%] min-h-screen'>
      <div className='sticky w-full top-44 flex flex-col h-fit border border-greyscaleGON-200 rounded-lg '>
        <Link
          href='/privacy'
          aria-label='privacy'
          className='py-3 px-4 hover:bg-primaryGON-50'
          passHref>
          <p className='p3-regular text-greyscaleGON-700 '>
            Pemberitahuan Privasi
          </p>
        </Link>
        <div className='w-full h-0.5 bg-greyscaleGON-200' />
        <Link
          href='/terms'
          aria-label='terms'
          className='py-3 px-4 hover:bg-primaryGON-50'
          passHref>
          <p className='p3-regular text-greyscaleGON-700 '>
            Syarat & Ketentuan
          </p>
        </Link>
      </div>
    </div>
  );
}
